module.exports = __webpack_public_path__ + "static/img/home_product_00_zh.dcfcdfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_00_zh.png
// module id = qJs2
// module chunks = 34